/**
 * WHAT AN ACCESSORY FAMILY IS CALLED ON SCREEN.
 *
 * The catalogue groups its accessories by `type` ("Underlay", "Protective Layer", "Edging", "Trims") and,
 * where the type is blank, by `sub_type` (Adhesive). `kindOfAccessory` in the contracts turns those into
 * one stable key; this turns the key into the two languages, in one place, so the switchboard under a
 * product and the Work panel's list can never name the same family differently.
 */
import type {T} from '@aiw/i18n';
import {ACCESSORY_KINDS, type AccessoryKind} from '@artemis-group/aiw-contracts';

const IDS: Record<string, string> = {
  underlay: 'accessory.kind.underlay',
  moisture_barrier: 'accessory.kind.moisture_barrier',
  scotia: 'accessory.kind.scotia',
  trims: 'accessory.kind.trims',
  adhesive: 'accessory.kind.adhesive',
  levelling: 'accessory.kind.levelling',
  stair: 'accessory.kind.stair',
};

/** A family the catalogue has that this list does not know still reads: its own name, unspaced. */
export function accessoryKindLabel(t: T, kind: string): string {
  const id = IDS[kind] as Parameters<T>[0] | undefined;
  return id ? t(id) : kind.replace(/_/g, ' ');
}

export {ACCESSORY_KINDS};
export type {AccessoryKind};
